<template>
    <div>
        <div class="el-cal-item">
            <div class="el-cal-item__title">
                <div class="el-cal-item__title-text">
                    <div class="fc-event__notification-number1">
                        {{ booking.arrived_count || 0 }}
                    </div>
                    <div class="fc-event__notification-number2">
                        /{{ booking.created_count || 0 }}
                    </div>
                    <img
                        src="/images/icon/images-icon-black.png"
                        style="margin-top: -3px; position: absolute; width: 16px; margin-left: 5px;"
                        v-if="booking.isImageAvailable"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'booking-notification-event',

    props: {
        booking: {
            type: Object,
            default: () => null,
        },

        element: {
            type: Object,
            default: () => {},
        },
    },

    mounted() {
        this.addStyles()
    },

    methods: {
        addStyles() {
            this.element.addClass('fc-event__notification fe-event__whiteBg')
            this.element.css('border-width', '2px')
            this.element.css('border-color', '#FFFFFF')
        },
    },
}
</script>
